import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'

import { campaignDetailsSave } from '@disco/state-management/actions/campaign-details-actions'
import { getCampaign } from '@disco/state-management/selectors/campaigns'

import type { EmailCampaign } from 'types/campaign'
import type { State } from 'types/redux'

import DocumentHeadTags from 'components/document-head-tags'
import PageContainer from 'components/ui/page-container'

import CampaignHeader from 'pages/campaigns/campaign-header'
import CampaignNav, {
  CHOOSE_RECIPIENTS_TAB,
} from 'pages/campaigns/campaign-nav'
import EditScheduledEmailModal from 'pages/campaigns/edit-scheduled-email-modal'

import type { RootState } from 'store/configureStore'

import CampaignRecipientList from './campaign-recipient-list'
import CampaignRecipientRules from './campaign-recipient-rules'

function mapStateToProps(
  state: RootState,
  ownProps: {
    params: {
      campaignId: string
    }
  },
) {
  return {
    campaign: getCampaign(state, {
      campaignId: parseInt(ownProps.params.campaignId),
    }),
  }
}

const mapDispatchToProps = {
  campaignDetailsSave,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

interface AdditionalProps {
  navigate: NavigateFunction
  params: {
    campaignId: string
  }
}

type Props = PropsFromRedux & AdditionalProps

class CampaignRecipientsPage extends React.Component<Props> {
  _handleNextStep = () => {
    const { campaign } = this.props
    const nextStep = `/campaigns/${campaign.id}/details`
    // performSave notifies then rethrows; nothing here can act on it
    if (campaign.status !== 'sent')
      Promise.resolve(this.props.campaignDetailsSave(campaign.id, true)).catch(
        () => {},
      )
    this.props.navigate(nextStep)
  }

  render() {
    return (
      <div className="Page_Content">
        <DocumentHeadTags title="Choose recipients | DISCO" />
        <CampaignHeader
          campaignId={this.props.params.campaignId}
          onNextClick={this._handleNextStep}
        />
        {this.props.campaign && !this.props.campaign.loading && (
          <PageContainer>
            <CampaignNav
              campaignId={this.props.params.campaignId}
              activeStep={CHOOSE_RECIPIENTS_TAB}
            />
            <PageContainer.Section>
              <div className="row row-flexbox-defaults">
                <div className="col-xs-3">
                  <CampaignRecipientRules />
                </div>
                <div className="col-xs-9">
                  <CampaignRecipientList />
                </div>
              </div>
            </PageContainer.Section>
            <EditScheduledEmailModal
              campaignId={this.props.params.campaignId}
            />
          </PageContainer>
        )}
      </div>
    )
  }
}

const ConnectedCampaignRecipientsPage = connector(CampaignRecipientsPage)

function CampaignRecipientsPageWithRouter(props: any) {
  const navigate = useNavigate()
  const params = useParams<{ campaignId: string }>()
  return (
    <ConnectedCampaignRecipientsPage
      {...props}
      navigate={navigate}
      params={params}
    />
  )
}

export default CampaignRecipientsPageWithRouter
